<template>
  <div class="top">
    <div class="block">
      <el-form :inline="true">
        <el-form-item>
          <el-autocomplete style="margin-right:5px;" placeholder="请输入交易对" v-model="pair" :fetch-suggestions="querySearchAsync" @change="findOne"></el-autocomplete>
          <el-button type="primary" @click="findOne()">搜索</el-button>
          <el-button type="primary" @click="exportExcel()">导出</el-button>
          <el-button type="success" @click="findOne">刷新</el-button>
          <el-button type="success" @click="editOrAdd">修改</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="volumeInfo" label-width="210px">
        <el-form-item label="虚拟深度起始价格配置：" class="main-label">
          <el-form :inline="true" label-width="auto">
            <el-form-item label="买盘起始档位：">
              <el-input-number v-model="volumeInfo.bidStartGear"></el-input-number>
              <span class="marginLeft5">档</span>
            </el-form-item>
            <el-form-item label="买盘起始价格比例：">
              <el-input-number v-model="volumeInfo.bidStartPriceRatio"></el-input-number>
            </el-form-item>
            <el-form-item label="买盘起始价格差值：">
              <el-input-number v-model="volumeInfo.bidStartPriceSpread"></el-input-number>
              <span class="marginLeft5">USDT</span>
            </el-form-item>
            <div class="tip">
              <span>虚拟深度卖1价格 = （当前卖盘n2档价格 + 【卖盘起始价格差值】） * （1 + 【卖盘起始价格比例】），n2 = 【卖盘起始档位】</span>
            </div>
          </el-form>
          <el-form :inline="true" label-width="auto">
            <el-form-item label="卖盘起始档位：">
              <el-input-number v-model="volumeInfo.askStartGear"></el-input-number>
              <span class="marginLeft5">档</span>
            </el-form-item>
            <el-form-item label="卖盘起始价格比例：">
              <el-input-number v-model="volumeInfo.askStartPriceRatio"></el-input-number>
            </el-form-item>
            <el-form-item label="卖盘起始价格差值：">
              <el-input-number v-model="volumeInfo.askStartPriceSpread"></el-input-number>
              <span class="marginLeft5">USDT</span>
            </el-form-item>
            <div class="tip">
              <span>虚拟深度买1价格 = （当前买盘n1档价格 - 【买盘起始价格差值】） * （1 - 【买盘起始价格比例】），n1 = 【买盘起始档位】</span>
            </div>
          </el-form>
        </el-form-item>
        <el-form-item label="虚拟深度档位价格配置：" class="main-label">
          <el-form :inline="true" label-width="auto">
            <el-form-item label="买盘虚拟深度档位数量：">
              <el-input-number v-model="volumeInfo.bidInventDepthGear"></el-input-number>
              <span class="marginLeft5">档</span>
            </el-form-item>
            <el-form-item label="买盘虚拟深度档位间价差范围值：">
              <el-input-number v-model="volumeInfo.bidInventPriceRange[0]"></el-input-number>
              <span style="padding: 0 15px">至</span>
              <el-input-number v-model="volumeInfo.bidInventPriceRange[1]"></el-input-number>
              <span class="marginLeft5">USDT</span>
            </el-form-item>
            <div class="tip">
              <span>相邻两个买盘虚拟深度档位间，价格差为【买盘虚拟深度档位间价差范围值】内随机数</span>
            </div>
          </el-form>
          <el-form :inline="true">
            <el-form-item label="卖盘虚拟深度档位数量：">
              <el-input-number v-model="volumeInfo.askInventDepthGear"></el-input-number>
              <span class="marginLeft5">档</span>
            </el-form-item>
            <el-form-item label="卖盘虚拟深度档位间价差范围值：">
              <el-input-number v-model="volumeInfo.askInventPriceRange[0]"></el-input-number>
              <span style="padding: 0 15px">至</span>
              <el-input-number v-model="volumeInfo.askInventPriceRange[1]"></el-input-number>
              <span class="marginLeft5">USDT</span>
            </el-form-item>
            <div class="tip">
              <span>相邻两个卖盘虚拟深度档位间，价格差为【卖盘虚拟深度档位间价差范围值】内随机数</span>
            </div>
          </el-form>
        </el-form-item>
        <el-form-item label="虚拟深度档位USDT额度配置：" class="main-label">
          <el-form-item label="买盘档位基础USDT额度：" label-width="180px" class="sub-label marginLeft20">
            <el-input-number v-model="volumeInfo.bidBaseAmountQuota"></el-input-number>
            <span class="marginLeft5">USDT</span>
          </el-form-item>
          <div class="tip marginLeft20">
            <p style="margin-bottom: 22px">虚拟深度买盘每个档位的USDT额度 = 【买盘档位基础USDT额度】 * </p>
            <p>等级一的币对：</p>
            <p>2/3 的概率：P = 5-10 间随机值</p>
            <p>2/9 的概率：P = 3-5 间随机值</p>
            <p>1/9 的概率：P = 1.2-3 间随机值</p>
            <p>其他币对：</p>
            <p>2/3 的概率：P = 3-5 间随机值</p>
            <p>1/3 的概率：P = 1.2-3 间随机值</p>
          </div>
          <el-form-item label="卖盘档位基础USDT额度：" label-width="180px" class="sub-label marginLeft20">
            <el-input-number v-model="volumeInfo.askBaseAmountQuota"></el-input-number>
            <span class="marginLeft5">USDT</span>
          </el-form-item>
          <div class="tip marginLeft20">
            <p style="margin-bottom: 22px">虚拟深度买盘每个档位的USDT额度 = 【买盘档位基础USDT额度】 * </p>
            <p>等级一的币对：</p>
            <p>2/3 的概率：P = 5-10 间随机值</p>
            <p>2/9 的概率：P = 3-5 间随机值</p>
            <p>1/9 的概率：P = 1.2-3 间随机值</p>
            <p>其他币对：</p>
            <p>2/3 的概率：P = 3-5 间随机值</p>
            <p>1/3 的概率：P = 1.2-3 间随机值</p>
          </div>
        </el-form-item>
        <el-form-item label="虚拟深度铺单刷新频率配置：" class="main-label">
          <el-form-item label="时间间隔（秒）" label-width="110px" prop="interval" class="sub-label marginLeft20">
            <el-input-number v-model="volumeInfo.timeInterval"></el-input-number>
          </el-form-item>

          <el-form-item label="币对等级" label-width="110px" class="sub-label marginLeft20 alignLeft">
            <el-radio-group v-model="volumeInfo.level">
              <el-radio class="radio" :label="1">1</el-radio>
              <el-radio class="radio" :label="2">2</el-radio>
              <el-radio class="radio" :label="3">3</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
      </el-form>
      <div class="op">
        <el-button type="primary" @click="editOrAdd">应用配置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import api from './api';
export default {
  name: "volumeSet",
  data() {
    return {
      pair: '',
      volumeInfo: {
        timeInterval: 0,
        bidInventPriceRange: [],
        askInventPriceRange: []
      }
    }
  },
  watch: {
    activePair: {
      handler(val) {
        if (val.pair) {
          this.pair = val.pair
          this.getList()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['allSymbols', 'activePair'])
  },
  methods: {
    querySearchAsync(queryString, cb) {
      let restaurants = this.allSymbols;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].toUpperCase()});
      }
      cb(suggest);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    async getList() {
      const { data: { list } } = await api.getTradeVolume({
        pair: this.pair,
        page: 1,
        size: 10
      })
      if (list.length === 1) {
        this.volumeInfo = list[0]
        this.volumeInfo.timeInterval = this.volumeInfo.timeInterval ? this.volumeInfo.timeInterval / 1000 : 0
        this.volumeInfo.bidInventPriceRange = this.volumeInfo.bidInventPriceRange ? this.volumeInfo.bidInventPriceRange.split(',') : []
        this.volumeInfo.askInventPriceRange = this.volumeInfo.askInventPriceRange ? this.volumeInfo.askInventPriceRange.split(',') : []
      } else {
        this.volumeInfo =  { pair: this.pair, timeInterval: 0, bidInventPriceRange: [], askInventPriceRange: [] }
      }
    },
    findOne() {
      this.getList()
    },
    exportExcel() {
      const columns = [{title:'币对', key:'pair'},{title:'买盘起始档位', key:'bidStartGear'},
        {title:'买盘起始价格比例', key:'bidStartPriceRatio'},{title:'买盘起始价格差值', key:'bidStartPriceSpread'},
        {title:'卖盘起始档位', key:'askStartGear'},{title:'卖盘起始价格比例', key:'askStartPriceRatio'},
        {title:'卖盘起始价格差值', key:'askStartPriceSpread'},{title:'买盘虚拟深度档位数量', key:'bidInventDepthGear'},
        {title:'买盘虚拟深度档位间价差范围值', key:'bidInventPriceRange'}, {title:'卖盘虚拟深度档位数量', key:'askInventDepthGear'},{title:'卖盘虚拟深度档位间价差范围值', key:'askInventPriceRange'},
        {title:'买盘档位基础USDT额度', key:'bidBaseAmountQuota'},  {title:'卖盘档位基础USDT额度', key:'askBaseAmountQuota'},
        {title:'时间间隔（秒）', key:'timeInterval'},{title:'币对等级', key:'level'},
        {title:'虚拟深度开关', key:'enabledFlag'}
      ]
      api.getTradeVolume({
        page: 1,
        size: 2000
      }).then( res => {
        if (res.code === 0) {
          res.data.list.forEach(item => {
            item.bidInventPriceRange = item.bidInventPriceRange ? item.bidInventPriceRange.split(',').join('至') : null
            item.askInventPriceRange = item.askInventPriceRange ? item.askInventPriceRange.split(',').join('至') : null
            item.timeInterval = item.timeInterval / 1000
          })
          api.export2Excel("虚拟深度",columns, res.data.list);
        }
      })
    },
    editOrAdd() {
      const sendData = JSON.parse(JSON.stringify(this.volumeInfo))
      sendData.timeInterval = sendData.timeInterval * 1000
      sendData.bidInventPriceRange = sendData.bidInventPriceRange ? sendData.bidInventPriceRange.join(',') : null
      sendData.askInventPriceRange = sendData.askInventPriceRange ? sendData.askInventPriceRange.join(',') : null
      if (!this.pair || (this.pair && !sendData.pair)) {
        return this.$message({ message: '请先搜索需要操作的交易对', type: 'warning' })
      }
      if (this.volumeInfo.id) {
        api.editTradeVolume(sendData).then(res => {
          if (res.code === 0) {
            this.$message({ message: '修改成功', type: 'success' })
            this.getList()
          }
        })
      } else {
        api.addTradeVolume(sendData).then(res => {
          if (res.code === 0) {
            this.$message({ message: '添加成功', type: 'success' })
            this.getList()
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.block {
  padding: 40px 30px 10px 30px
}
/deep/.main-label {
  margin-bottom: 0;
  .el-form-item__label {
    float: none;
  }
  .el-form-item__content {
    margin-left: 0px !important;
  }
  .el-form {
    margin-left: 20px;
    .el-form-item {
      margin-bottom: 22px;
    }
  }
  .sub-label {
    margin-bottom: 22px;
    .el-form-item__label {
      float: left;
    }
  }
  .tip {
    color:#bbb;
    line-height: 14px;
    margin-bottom: 22px;
  }
  .marginLeft20 {
    margin-left: 20px;
  }
  .alignLeft {
    .el-form-item__label {
      text-align: left;
    }
  }
  .marginLeft5 {
    margin-left: 5px;
  }
}
</style>